import { getLoginUrl } from '@utils/index';
import jsBridge from '@utils/jsBridge';
import { getToken, isTokenExpired } from '@utils/loginHelper';
import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';

const useLogin = (enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const expired = isTokenExpired();
    if (!expired) {
      return;
    }
    const loginUrl = getLoginUrl();
    // make no sense to redirect to login page in the webview since it not a ideal webview experience
    // we may need to monitor this case
    const canUseBridge = jsBridge.canUseBridge();
    if (canUseBridge) {
      datadogRum.addAction('Redirect to login', {
        reason: 'Token expired',
        hasJWT: !!getToken(),
      });
      return;
    }
    window.location.replace(loginUrl);
  }, [enabled]);
};

export default useLogin;
